<accredible-base-footer *transloco="let t; lang: 'en|static'; read: 'directory_psypact_gov.footer'">
  <div class="content">
    <div class="inner-content">
      <div class="links">
        <nav role="navigation">
          <ul [attr.aria-label]="t('aria_footer_links')">
            <li>
              <a href="https://psypact.gov/" target="_blank">
                {{ t('home') }}
              </a>
            </li>

            <li>
              <a href="https://psypact.gov/page/About" target="_blank">
                {{ t('about') }}
              </a>
            </li>

            <li>
              <a href="https://psypact.gov/page/LegislativeResources" target="_blank">
                {{ t('legislative') }}
              </a>
            </li>

            <li>
              <a href="https://psypact.site-ym.com/page/Governance" target="_blank">
                {{ t('governance') }}
              </a>
            </li>

            <li>
              <a href="https://psypact.gov/page/PracticeUnderPSYPACT" target="_blank">
                {{ t('practice') }}
              </a>
            </li>

            <li>
              <a href="https://psypact.gov/page/Commission" target="_blank">
                {{ t('commission') }}
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="advancing" [innerHTML]="t('advancing')"></div>

      <div class="legal-disclaimer">
        <div [innerHTML]="t('legal_disclaimer_text1')"></div>

        <div [innerHTML]="t('legal_disclaimer_text2')"></div>
      </div>

      <div class="membership" [innerHTML]="t('membership')"></div>
    </div>
  </div>
</accredible-base-footer>
